import { HostingEnvironment } from '@opengov/psp-contract';

import { detectPspHostingEnvironment, getHostingEnvironmentDomain } from './utils';

/**
 * Environments whose controlpanel origin serves the Admin Settings rewrite.
 *
 * Add an environment here only once its cutover is live: before it, `/access`
 * and `/entity` on that controlpanel origin still route to legacy, which has no
 * `/platform-admin-settings/psp/index.js`. DEVELOPMENT is included because local
 * PSP resolves to the integration domain, where the rewrite is live.
 */
const REWRITE_ENVIRONMENTS: ReadonlySet<HostingEnvironment> = new Set([
  HostingEnvironment.DEVELOPMENT,
  HostingEnvironment.INTEGRATION,
  HostingEnvironment.STAGING,
  HostingEnvironment.PRODUCTION,
]);

/**
 * Where the Admin Settings module for `/access` and `/entity` is loaded from.
 *
 * The rewrite (platform-admin-settings) ships one module that serves both
 * surfaces — `baseRouterPath` tells it which — at
 * `/platform-admin-settings/psp/index.js` on the controlpanel origin. It serves
 * every environment since the production cutover. The set above is
 * kept rather than collapsed so a rollback is one line: drop PRODUCTION and the
 * shell goes back to legacy's per-surface bundles, which legacy's Services
 * still serve.
 *
 * @param legacyPath legacy's bundle for this route, e.g.
 *   `/access/assets/access-management-psp.js`
 */
export const adminSettingsModuleUrl = (legacyPath: string): string => {
  const path = REWRITE_ENVIRONMENTS.has(detectPspHostingEnvironment())
    ? '/platform-admin-settings/psp/index.js'
    : legacyPath;
  return `https://controlpanel.${getHostingEnvironmentDomain()}${path}`;
};
